import { App } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiPost, errorMessage, qk } from "@/shared/api";

/**
 * Пометка аккаунта служебным (доработки §5, §7).
 *
 * Отдельная мутация, а не флаг в блокировке: блокировка закрывает человеку
 * доступ, а эта пометка лишь убирает его из публичных рейтингов и из
 * аудитории роботов. Инвалидируется и журнал: §7 требует, чтобы такое решение
 * оператора читалось в аудите.
 */
export function useMarkServiceUser(userId: number) {
  const queryClient = useQueryClient();
  const { message } = App.useApp();

  return useMutation({
    mutationFn: (input: { is_service: boolean; comment?: string }) =>
      apiPost("/api/v1/admin/users/{user_id}/service", {
        params: { user_id: userId },
        body: input,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qk.user(userId) });
      void queryClient.invalidateQueries({ queryKey: ["users"] });
      void queryClient.invalidateQueries({ queryKey: ["audit"] });
    },
    onError: (error) => {
      void message.error(errorMessage(error));
    },
  });
}
